import React from 'react'

import {CloseButton} from './close-button'
import {CopyButton} from './copy-button'
import {GetAppButton} from './get-app-button'
import {GoToAppButton} from './go-to-app-button'
import {useActionButton} from './PromoBannerButton.hooks'
import type {ActionButtonProps, Props} from './PromoBannerButton.types'

const ActionButton: React.FC<ActionButtonProps> = ({onClick, ...props}) => {
  switch (props.action) {
    case 'close':
      return <CloseButton {...props} onClick={onClick} />
    case 'go-to-app':
      return <GoToAppButton {...props} onClick={onClick} />
    case 'copy-coupon':
      return <CopyButton {...props} onClick={onClick} />
    case 'get-app':
    default:
      return <GetAppButton {...props} onClick={onClick} />
  }
}

const Base: React.FC<Props> = props => {
  const onClick = useActionButton(props)

  return <ActionButton {...props} onClick={onClick} />
}

export const PromoBannerButton = React.memo(Base)
